export const classificationPropertyMap = {
    Name: { id: 0x85b6, propertyType: 'String' },
    Description: { id: 0x85b7, propertyType: 'String' },
    Id: { id: 0x85b8, propertyType: 'String' },
    IsClassified: { id: 0x85b5, propertyType: 'Boolean' },
};

export const MESSAGE_CLASSIFICATION_INFOBAR_MESSAGE_ID = 'messageClassification';
